define(
	'actions/contacts',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			init: function(params) {
			},
			addItem: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATED_CONTACT,
					data: params
				});
			},
			updatedItem: function(guid, params) {
				AppDispatcher.dispatch({
					actionType: Constants.UPDATED_CONTACT,
					guid: guid,
					data: params
				});
			},
			deletedItem: function(guid) {
				AppDispatcher.dispatch({
					actionType: Constants.DELETED_CONTACT,
					guid: guid
				});
			},
			pull: function(parent, onComplete) {
				var self = this;
				var items = [];
				
				window.api.request("contacts").each(function iterator (index, item) {
					items.push({
						guid: item.guid,
						email: item.email,
                        first_name: item.first_name,
                        last_name: item.last_name
					});
				}, function () {
					self.addItem(items);
					if (typeof onComplete === "function") {
						onComplete();
					}
				});
			},
			delete: function(guid) {
				var self = this;
				window.api.request("contacts", guid)
				.delete({})
				.done(function (response) {
					self.deletedItem(guid);
				})
				.fail(function (jqXHR, textStatus, errorThrown) {
					alert("Uh-Oh!", jqXHR.responseText || "Your request could not be completed at this time.", {
						message: "Dismiss"
					});
				});
			},
            createContact: function(contactsList, success, failure) {
				var self = this;

                _.each(contactsList, function(contact) {
                    window.api.request("contacts").create({
                        email: contact.email,
                        first_name: contact.first_name,
                        last_name: contact.last_name
                    })
                    .done(function(response) {
                        self.addItem([{
                            guid: response.guid,
                            email: response.email,
                            first_name: response.first_name,
                            last_name: response.last_name
                        }]);

						success(response);
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        if(typeof failure == "function") {
                            failure(jqXHR, textStatus, errorThrown);
                        }
                    });
                });
			},
			/**
			 * 
			 * @param {array} contactsList array containing all fo the contacts to add 
			 * @param {function} success callback function for successful API request
			 * @param {function} failure callback function for failed API request
			 */
			bulkCreateContacts: function(contactsList, success, failure) {
				var self = this;
				window.api.request("contacts/bulk").create({
					// Need to json stringify the data as our PHP config only allows 1000
					data: JSON.stringify(contactsList)
				})
				.done(function(response) {
					self.addItem(response.contacts);
					success(response);
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if(typeof failure == "function") {
						failure(jqXHR, textStatus, errorThrown);
					}
				});
			},
            updateContact: function(guid, params, success, failure) {
				var self = this;

				window.api.request("contacts", guid).update({'data' : JSON.stringify(params)}).done(function(response) {
					var data = {
						email: response.data.email,
                        first_name: response.data.first_name,
                        last_name: response.data.last_name
					};

					self.updatedItem(response.data.guid, data);
				}).fail(function() {
					if(typeof failure == "function") {
	                    failure();
	                }
                });
			},
            importContactsFromCSV: function(csvFile, showResults) {
				var self = this;

				var request = window.api.request("contacts", "csv");
				request.xhrParams.processData = false;
				request.xhrParams.contentType = false;

				var formData = new FormData();
				formData.append("csv", csvFile);

				request.create(formData).done(function(response) {
					showResults(response.data);
				});
			}
		});
	}
);
